export default {
  userMenu: [
    {
      name: 'packages',
      caption: 'ПАКЕТЫ',
      parent_id: null,
      id: 22,
      link: '/packages',
      children: [
        {
          name: 'packages-list',
          caption: 'Список пакетов',
          parent_id: 22,
          id: 23,
          link: '/packages/list',
          children: []
        }
      ]
    },
    {
      name: 'support',
      caption: 'ТЕХПОДДЕРЖКА',
      parent_id: null,
      id: 24,
      link: '/support',
      children: [
        {
          name: 'support-packages-list',
          caption: 'Список пакетов',
          parent_id: 24,
          id: 25,
          link: '/support/packages',
          children: []
        }
      ]
    },
    {
      name: 'administration',
      caption: 'Управление',
      parent_id: null,
      id: 20,
      link: '/administration',
      children: [
        {
          name: 'organisations-users',
          caption: 'Организации и пользователи',
          parent_id: 20,
          id: 7,
          link: '/administration/organisations-users',
          children: []
        }
      ]
    },
    {
      name: 'piportal-api-search',
      caption: 'ПАКЕТЫ FILL-BILL',
      parent_id: null,
      id: 1,
      link: '/piportal',
      children: []
    },
    {
      name: 'pi-transit',
      caption: 'ПИ и ТРАНЗИТ',
      parent_id: null,
      id: 2,
      link: '/pi-transit',
      children: []
    },
    {
      name: 'shipping-display',
      caption: 'ТАБЛО СУДОЗАХОДОВ',
      parent_id: null,
      id: 3,
      link: '/tablo',
      children: []
    },
    {
      name: 'consignments',
      caption: 'ВИРТУАЛЬНЫЙ ПАКЕТ',
      parent_id: null,
      id: 4,
      link: '/consignments',
      children: []
    },
    {
      name: 'download',
      caption: 'СКАЧАТЬ',
      parent_id: null,
      id: 5,
      link: '/download',
      children: []
    },
    {
      name: 'reports',
      caption: 'ОТЧЕТЫ',
      parent_id: null,
      id: 6,
      link: '/reports',
      children: [
        {
          name: 'web_client_reports_otvt_tk',
          caption: 'Пакеты ТК (старый)',
          parent_id: 6,
          id: 14,
          link: '/reports/web_client_reports_otvt_tk'
        },
        {
          name: 'web_client_reports_pi_classic',
          caption: 'ПИ (старый)',
          parent_id: 6,
          id: 15,
          link: '/reports/web_client_reports_pi_classic'
        },
        {
          name: 'web_client_reports_pi_from_uin',
          caption: 'ПИ (с УИН)',
          parent_id: 6,
          id: 16,
          link: '/reports/web_client_reports_pi_from_uin'
        },
        {
          name: 'web_client_reports_transite_vypusk',
          caption: 'Транзит',
          parent_id: 6,
          id: 17,
          link: '/reports/web_client_reports_transite_vypusk'
        },
        {
          name: 'package-statistic',
          caption: 'Статистика по пакетам',
          parent_id: 6,
          id: 19,
          link: '/reports/package-statistic',
          children: []
        },
        {
          name: 'sales-statistic',
          caption: 'Статистика продаж',
          parent_id: 6,
          id: 21,
          link: '/reports/sales-statistic',
          children: []
        },
        {
          name: 'report_fixed_packages',
          caption: 'Тариф минимальный',
          parent_id: 6,
          id: 30,
          link: '/reports/report_fixed_packages',
          children: []
        }
      ]
    },
    {
      name: 'product_client',
      caption: 'ПРОГРАММА',
      parent_id: null,
      id: 26,
      link: '/product',
      children: [
        {
          name: 'client',
          caption: 'Скачать дистрибутив',
          parent_id: 26,
          id: 27,
          link: '/product/client',
          children: []
        }
      ]
    },
    {
      name: 'usermanagment_otvt',
      caption: 'Организации ОТВТ',
      parent_id: null,
      id: 28,
      link: '/otvt-groups-users',
      children: []
    }
  ],
  adminMenu:
    [
      {
        name: 'detailing',
        caption: 'ДЕТАЛИЗАЦИЯ',
        parent_id: null,
        id: 8,
        link: '/detailing',
        children: []
      },
      {
        name: 'statistic',
        caption: 'СТАТИСТИКА ПРОДАЖ',
        parent_id: null,
        id: 9,
        link: '/statistic',
        children: []
      },
      {
        name: 'lead',
        caption: 'ЛИДЫ',
        parent_id: null,
        id: 10,
        link: '/lead',
        children: []
      },
      {
        name: 'demo',
        caption: 'ДЕМО',
        parent_id: null,
        id: 11,
        link: '/demo',
        children: []
      },
      {
        name: 'company-profile',
        caption: 'ПРОФИЛЬ КОМПАНИИ',
        parent_id: null,
        id: 12,
        link: '/company-profile',
        children: []
      },
      {
        name: 'user-profile',
        caption: 'ПРОФИЛЬ ПОЛЬЗОВАТЕЛЯ',
        parent_id: null,
        id: 13,
        link: '/user-profile',
        children: []
      },
      {
        name: 'site-fill-bill',
        caption: 'САЙТ FILL-BILL',
        parent_id: null,
        id: 18,
        link: '/site-fill-bill',
        children: [
          {
            name: 'fill-bill-categories',
            caption: 'Категории и записи',
            parent_id: 18,
            id: 19,
            link: '/site-fill-bill/categories',
            children: []
          }
        ]
      }
    ]
}
